const upsert = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const upsertLink = (rel, href) => {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

export function setNoIndex() {
  document.querySelector('link[rel="canonical"]')?.remove();
  upsert("name", "robots", "noindex,nofollow");
}

const OG_IMAGE =
  "https://static.prod-images.emergentagent.com/jobs/f24c2250-9a43-4fd4-83d8-5e2d62e8428b/images/8bb35a07c2d3852af42990f62a48f3893d7b3a764ebdea926fb78888f3c7140e.jpeg";

export function setSeo(title, description) {
  document.title = title;
  upsert("name", "description", description);
  upsert("name", "robots", "index,follow");
  upsertLink("canonical", window.location.origin + window.location.pathname);
  upsert("property", "og:title", title);
  upsert("property", "og:description", description);
  upsert("property", "og:type", "website");
  upsert("property", "og:site_name", "HairHelp");
  upsert("property", "og:locale", "it_IT");
  upsert("property", "og:url", window.location.origin + window.location.pathname);
  upsert("property", "og:image", OG_IMAGE);
  upsert("property", "og:image:alt", "HairHelp — esperienza reale sui sistemi capillari");
  upsert("name", "twitter:card", "summary_large_image");
  upsert("name", "twitter:title", title);
  upsert("name", "twitter:description", description);
  upsert("name", "twitter:image", OG_IMAGE);
}
